import Payment from 'payment';
import { object, string } from 'yup';

import { makeValidateSync } from '../../lib/form/utils';
import { intl } from '../../lib/translation/TranslationProvider';
import { validationMessages } from '../../modules/localization/validationMessages';

export const ZIP_CODE_LENGTH = 5;

export const schema = object({
  cardNumber: string().test(
    'card-number',
    intl.formatMessage(validationMessages['validation:form:card-number:general']),
    (value) => (value ? Payment.fns.validateCardNumber(value) : false),
  ),
  expirationDate: string().test(
    'expiration-date',
    intl.formatMessage(validationMessages['validation:form:card-expiration:general']),
    (value) => (value ? Payment.fns.validateCardExpiry(value) : false),
  ),
  cvv: string().test('cvv', intl.formatMessage(validationMessages['validation:form:card-cvv:general']), (value) =>
    value ? Payment.fns.validateCardCVC(value) : false,
  ),
  cardholderName: string().required(intl.formatMessage(validationMessages['validation:form:cardholder-name:required'])),
  billingZip: string().matches(
    new RegExp(`^\\d{${ZIP_CODE_LENGTH}}$`),
    intl.formatMessage(validationMessages['validation:form:zip-code:general']),
  ),
});

export const formValidationSchema = makeValidateSync(schema);
